import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  Stack,
  TextField,
} from '@mui/material'
import { stackGap } from '../../../Constants&Theme/Spacing'
import { formatValueDate } from '../../../Functions/FormatValues'
import { LocalShipping } from '@mui/icons-material'
import React, { useEffect, useState } from 'react'
import { usePyGet } from '../../../APIs/Hooks/PyAPIHooks'
import { UseQueryResult } from 'react-query'

function lookupVanRun(id: any, runs: UseQueryResult<any> | undefined) {
  if (runs?.data) {
    return runs.data.find((r: any) => r.VanRunID === id)
  } else {
    return {}
  }
}

export function calcVanRunLabel(
  vanRunsQuery: UseQueryResult<any> | undefined,
  fields: any,
  savedData?: any,
) {
  if (vanRunsQuery?.isFetching) return 'Loading...'
  const vanRun = lookupVanRun(
    fields?.VanRunID ?? savedData?.VanRunID,
    vanRunsQuery,
  )
  return `${formatValueDate(vanRun?.VanRunDate, 'yyyy/MMM/dd')} - ${vanRun?.VanName}`
}
function DeliveryDetailsFields({
  fields,
  setFields,
  savedData,
}: {
  fields: any
  setFields: any
  savedData?: any
}) {
  const vanRunsQuery = usePyGet(
    [
      '/vanrun/by_destination/',
      fields?.FacilityID ?? savedData?.ToFacility ?? '',
    ],
    !!fields?.FacilityID || !!savedData?.ToFacility,
  )
  const [courier, setCourier] = useState(false)

  useEffect(() => {
    if (savedData?.VanRunID) {
      setCourier(
        (vanRunsQuery.data ?? []).filter(
          (v: any) => v?.VanRunID === savedData?.VanRunID,
        )?.[0]?.isCourier === 1,
      )
    }
  }, [savedData?.VanRunID, vanRunsQuery.data])
  return (
    <Stack
      gap={stackGap.col}
      width={1}
    >
      <Stack
        gap={stackGap.row}
        width={1}
        direction={'row'}
      >
        <Autocomplete
          value={
            (
              fields?.VanRunID ??
              ((
                courier ===
                !!lookupVanRun(
                  fields?.VanRunID ?? savedData?.VanRunID,
                  vanRunsQuery,
                )?.isCourier
              ) ?
                savedData?.VanRunID
              : null)
            ) ?
              {
                value: fields?.VanRunID ?? savedData?.VanRunID ?? null,
                label: calcVanRunLabel(vanRunsQuery, fields, savedData),
              }
            : null
          }
          disabled={vanRunsQuery.isLoading}
          isOptionEqualToValue={(option, value) => {
            return option.value === value.value
          }}
          onChange={(event: any, newValue: any) => {
            setFields((f: any) => {
              let newFields = {
                ...f,
                VanRunID: newValue?.value ?? undefined,
                courier: newValue?.courier,
              }
              if (!newValue?.courier) {
                delete newFields['DeliveryAddress']
              }
              return newFields
            })
          }}
          renderInput={(params) => (
            <TextField
              required
              label={courier ? 'Courier Date' : 'Van Run'}
              {...params}
            />
          )}
          loading={vanRunsQuery.isFetching}
          fullWidth
          options={
            vanRunsQuery?.data ?
              vanRunsQuery.data
                .filter((v: any) => !!v.isCourier === courier)
                .sort((a: any, b: any) => {
                  return a.VanRunDate.localeCompare(b.VanRunDate)
                })
                .map((item: any) => {
                  const runDate = formatValueDate(
                    item.VanRunDate,
                    'dd/MMM/yyyy',
                  )
                  return {
                    value: item.VanRunID,
                    label:
                      item.isCourier ? runDate : `${runDate} - ${item.VanName}`,
                    courier: item.isCourier,
                  }
                })
            : []
          }
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={courier}
              onChange={(e) => {
                setFields((f: any) => {
                  let newFields = f
                  delete newFields['VanRunID']
                  if (!e.target.checked) {
                    delete newFields['DeliveryAddress']
                  }
                  return newFields
                })
                setCourier(e.target.checked)
              }}
            />
          }
          label="Courier"
        />
      </Stack>
      {courier && (
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LocalShipping />
              </InputAdornment>
            ),
          }}
          fullWidth
          placeholder={'Address for Courier'}
          name={'DeliveryAddress'}
          required={courier}
          label={'Delivery Address'}
          onChange={(e) => {
            setFields((f: any) => {
              return { ...f, [e.target.name]: e.target.value }
            })
          }}
          value={fields?.DeliveryAddress ?? savedData?.DeliveryAddress ?? ''}
        />
      )}
      <TextField
        fullWidth
        multiline
        minRows={6}
        onChange={(e) => {
          setFields((f: any) => {
            return { ...f, DeliveryInstructions: e.target.value }
          })
        }}
        label={'Delivery Instructions'}
        sx={{ height: 1 }}
        value={
          fields?.DeliveryInstructions ?? savedData?.DeliveryInstructions ?? ''
        }
      />
    </Stack>
  )
}

export default DeliveryDetailsFields
